import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-platform-button',
  templateUrl: './platform-button.component.html',
  styleUrl: './platform-button.component.scss',
  standalone: false
})
export class PlatformButtonComponent implements OnInit {
  usage = `
        <ui-platform-button
                  [type]="'secondary'"
                  [icon]="'check'"
                  [iconPlacement]="'right'"
                  [label]="'Right'"
          >
          </ui-platform-button>
    `;

  import = `
    import {UiPlatformButtonComponent} from 'ui-platform';
  `;

  constructor() {}

  ngOnInit(): void {}
}
